import React from 'react'
import { clsx } from 'clsx'

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
  }

  return (
    <div className="flex items-center justify-center">
      <div
        className={clsx(
          'animate-spin rounded-full border-2 border-transparent bg-gradient-to-r from-blue-500 to-purple-500 shadow-lg',
          sizeClasses[size],
          className
        )}
        style={{
          background: 'conic-gradient(from 0deg, #3b82f6, #8b5cf6, #3b82f6)',
          borderRadius: '50%',
        }}
      >
        <div className={clsx(
          'rounded-full bg-gray-900',
          size === 'sm' ? 'w-3 h-3' : size === 'md' ? 'w-5 h-5' : size === 'lg' ? 'w-7 h-7' : 'w-11 h-11'
        )} />
      </div>
    </div>
  )
}

export default LoadingSpinner
